import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';

type GetFYIJobsParams = {
    name?: string;
    excludeClosed?: boolean;
};

type GetFYIJobsResponse = {
    jobs: { name: string; id: string }[];
};
async function getFYIJobs(fyiEntityId: number, params: GetFYIJobsParams): Promise<GetFYIJobsResponse> {
    const { data } = await api.get('/fyi-docs/jobs', { params: { fyiEntityId, ...params } });
    return data;
}

export function useFYIJobs(fyiEntityId: number, params: GetFYIJobsParams): UseQueryResult<GetFYIJobsResponse, unknown> {
    return useQuery(['fyi', 'jobs', fyiEntityId, Object.values(params)], () => getFYIJobs(fyiEntityId, params), {
        keepPreviousData: true,
    });
}
